import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IResponseData<T = Row> {
  data?: {
    next: boolean;
    total: number;
    limit: number;
    page: number;
    rows: T[];
    columns: Column[];
  };
}

export interface Column {
  type: string;
  id: string;
  label: string;
}

export interface Row {
  [id: string]: any;
}

export interface ITableData<T = Row> {
  totalPages: number;
  page: number;
  totalItems: number;
  filtersParams: Filters;
  limit: number;
  next: boolean;
  rows: T[];
}

export interface Filters {
  [filter: string]: string[];
}

export const TABLES_SERVICE_TOKEN = new InjectionToken<ITablesService>('ITablesService');

export interface ITablesService {
  data<T>(url: string, limit: number, page: number, filters?: Filters, order_values?: IOrderValues): Observable<ITableData<T>>;
}

export interface IOrderValues {
  [key: string]: 'asc' | 'desc';
}
